import { WorkspaceHomeScene } from '@/features/workspaces/WorkspaceHomeScene';
import { useLocalSearchParams } from 'expo-router';

export default function WorkspaceDetailScreen() {
  const { id } = useLocalSearchParams<{ id?: string }>();
  const organizationID = typeof id === 'string' ? id : '';

  return <WorkspaceHomeScene organizationID={organizationID} />;
}
